import styled from '@emotion/styled';
import { Button, Icon } from '../../styles';
import { IconPause, IconPlay, IconVolumeOff, IconVolumeUp } from '../../icons';
import { __t } from '../../i18n';

type ContentPlayerShelfProps = {
  isPlaying: boolean;
  isMuted: boolean;
  onTogglePlay: () => void;
  onToggleMute: () => void;
};

export default function ContentPlayerShelf({
  isPlaying,
  isMuted,
  onTogglePlay,
  onToggleMute,
}: ContentPlayerShelfProps) {
  return (
    <Shelf>
      <ControlsWrapper>
        <ControlButton
          onClick={onTogglePlay}
          aria-label={isPlaying ? __t('player.pause') : __t('content.watch')}
        >
          <Icon cursor="pointer">{isPlaying ? <IconPause /> : <IconPlay />}</Icon>
        </ControlButton>
        <ControlButton
          onClick={onToggleMute}
          aria-label={isMuted ? __t('player.unmute') : __t('player.mute')}
        >
          <Icon cursor="pointer" size="large">
            {isMuted ? <IconVolumeOff /> : <IconVolumeUp />}
          </Icon>
        </ControlButton>
      </ControlsWrapper>
    </Shelf>
  );
}

const Shelf = styled.div(({ theme }) => ({
  position: 'absolute',
  bottom: 40,
  left: 40,
  right: 40,
  zIndex: 5,
  direction: 'ltr',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 16,

  [theme.breakpoints.down('md')]: {
    left: theme.spacing(2),
    right: theme.spacing(2),
    bottom: theme.spacing(2),
    gap: theme.spacing(1.5),
  },
}));

const ControlsWrapper = styled.div({
  display: 'inline-flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 8,
  padding: 12,
  borderRadius: 16,
  background: 'rgba(20, 20, 20, 0.35)',
  backdropFilter: 'blur(14px)',
  WebkitBackdropFilter: 'blur(14px)',
  border: '1px solid rgba(255, 255, 255, 0.08)',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.05)',
  overflow: 'hidden',
});

const ControlButton = styled(Button)(() => ({
  height: '32px',
  width: '32px',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'transparent !important',
}));
